export const WATCHLIST_IGNORING_PROPERTY_MESSAGES = {
  SUCCESS: 'The watchlist ignoring properties were successfully saved',
};


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/watchListIgnoringPropertyMessages.js